import React from 'react'
import { get } from 'lodash'

const ContainerTextContent = ({ content }) => {
  const cont = get(content, 'body.childMarkdownRemark.html')

  function wrapTables (html) {
    if (typeof window === 'undefined') return html
    // eslint-disable-next-line no-undef
    const parser = new DOMParser()
    const doc = parser.parseFromString(html, 'text/html')

    const tables = doc.querySelectorAll('table')
    tables.forEach(table => {
      const wrapper = doc.createElement('div')
      wrapper.className = 'table-wrapper'
      table.parentNode.insertBefore(wrapper, table)
      wrapper.appendChild(table)
    })

    return doc.body.innerHTML
  }

  const wrappedHtml = wrapTables(cont)

  return (
    <div className='row justify-content-center'>
      <div className='col-10'>
        <div className='wysiwyg-content' dangerouslySetInnerHTML={{ __html: wrappedHtml }} />
      </div>
    </div>
  )
}

export default ContainerTextContent
